import { BRAND } from "../../type/EnumBrand";
import { IBrand } from "../../type/IBrand";

export const chandlerlimited: IBrand = {
  id: "chandler-limited",
  name: BRAND.CHANDLER_LIMITED,
  logo: "/logo/chandler-limited-logo.png",
  website: "https://chandlerlimited.com/",
  description: `
  Looking for that color?
`
}